export const MAP_OPTIONS: ymaps.IMapOptions = {
  copyrightUaVisible: false,
  suppressMapOpenBlock: true,
  copyrightProvidersVisible: false,
  yandexMapDisablePoiInteractivity: true,
};

export type AddressSuggestion = {
  uri: string;
  value: string;
  unrestricted_value: string;
};

export enum DeliveryTabsEnum {
  CourierOrOrderPoint = 'courierOrOrderPoint',
  Takeout = 'takeout',
}

export enum DeliveryOptionEnum {
  Courier = 'courier',
  OrderPoint = 'orderPoint',
}
